/** All supported weight units */
export type WeightUnit = 'Ounces' | 'Pounds' | 'Grams' | 'Kilograms';
export type BaseWeightUnit = 'Ounces' | 'Grams';

export const WEIGHT_UNIT_OUNCES: BaseWeightUnit = 'Ounces';
export const WEIGHT_UNIT_GRAMS: BaseWeightUnit = 'Grams';
export const WEIGHT_UNIT_POUNDS: WeightUnit = 'Pounds';
export const WEIGHT_UNIT_KILOGRAMS: WeightUnit = 'Kilograms';

/** Seller settings API values (singular form) */
export const WEIGHT_SETTING_OUNCE = 'Ounce';
export const WEIGHT_SETTING_GRAM = 'Gram';

/** Weight value with unit */
export type Weight = {
  value: number;
  unit: WeightUnit;
};
